import './keyValueDetection.less'
import { DetectionKeys } from './detectionKeys'
import { AssociatedPatterns } from './patterns'
import { TestInputs } from '../testInputs'
import { Alert } from '@lightbeamai/design-system'
import React from 'react'
import { useIntl } from 'react-intl'

export const KeyValueDetection = () => {
  const intl = useIntl()
  return (
    <div>
      <Alert
        type="info"
        className="key-value-alert"
        showIcon
        message={intl.formatMessage({
          id: 'attributeManagementSettings.customAttributes.detection.keyValue.alert'
        })}
        closable
      />
      <div className="key-value-configuration-container-for-policy">
        <DetectionKeys />
        <AssociatedPatterns />
      </div>
      <div className="xs-mt-16">
        <TestInputs />
      </div>
    </div>
  )
}
